const LocalesEnum = {
  DEFAULT: 'en',
  EN: 'en',
};

Object.freeze(LocalesEnum);

export default LocalesEnum;
